import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

function Convocatorias() {
  const aspirantes = [
    // Ejemplo para probar
    // { nombre: 'Ana López', documentos: 'https://ejemplo.com/documento.pdf' }
  ];

  return (
    
    <Container className="mt-2">
      {/* Imagen de encabezado */}
            <h1 className="mb-12 text-center">Resultados de la convocatoria que contiene el procedimiento de consulta pública y postulación en términos en lo dispuesto por el artículo 97 de la Ley de Víctimas para el Estado de Hidalgo </h1>
      <div className="image-container text-center mb-4">
        <img
          src="/Img/wall.jpg"
          alt="Banner"
          className="img-fluid"
          style={{ pointerEvents: 'none', userSelect: 'none' }}
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>


      <Row>
        {aspirantes.map((aspirante, idx) => (
          <Col key={idx} md={3} className="mb-4">
            <Card className="h-100 d-flex flex-column justify-content-between">
              <Card.Body className="text-center">
                <Card.Title>{aspirante.nombre}</Card.Title>
              </Card.Body>
              <Card.Footer className="d-flex flex-wrap justify-content-center gap-2 px-3 py-2">
                <Button
                  variant="primary"
                  href={aspirante.documentos}
                  target="_blank"
                  size="sm"
                >
                  Documentos públicos
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Convocatorias;
